/**
 * Autenticação — NÃO altera o modelo do legado (regra inviolável §7.6/2).
 *
 * A credencial é o par `userId` + `email` lido de cookies (gravados pela extensão) e
 * enviado como headers `id`/`email`/`source` em cada request. Centralizado aqui para,
 * no futuro, plugar `Authorization: Bearer` sem tocar em componentes.
 */
import { getCookie } from './cookies';
import { getBrand } from '../config/brand';

export interface AuthCredentials {
  userId: string;
  email: string;
  source: string;
}

export function readAuth(): AuthCredentials | null {
  const userId = getCookie('userId');
  const email = getCookie('email');
  if (!userId || !email) return null;
  const source = getCookie('extension') ?? getBrand().source;
  return { userId, email, source };
}

export function isAuthenticated(): boolean {
  return readAuth() !== null;
}

/**
 * Headers de auth. O painel legado usa dois estilos de header conforme o endpoint:
 *  - style 'app'       → { id, email, source }         (rotas /app/*)
 *  - style 'extension' → { userid, email, source }     (rotas da extensão: /search, /leads…)
 */
export function authHeaders(style: 'app' | 'extension' = 'app'): Record<string, string> {
  const auth = readAuth();
  if (!auth) return {};
  const headers: Record<string, string> = { email: auth.email, source: auth.source };
  if (style === 'extension') headers['userid'] = auth.userId;
  else headers['id'] = auth.userId;
  return headers;
}
